import { useState } from 'react'
import Button from '@mui/material/Button'
import ListItemIcon from '@mui/material/ListItemIcon'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import CheckIcon from '@mui/icons-material/Check'
import { ArrowDownSLineIcon } from 'components/icons'

const ROW_OPTIONS = [ 10, 20, 50 ]

export type RowsPerPageMenuProps = {
	rowsPerPage?: number,
	setRowsPerPage: ( rows: number ) => void,
}

// The MUI rows-per-page control shared by Pagination and CursorPagination.
export default function RowsPerPageMenu( { rowsPerPage, setRowsPerPage }: RowsPerPageMenuProps ) {
	const [ anchorEl, setAnchorEl ] = useState<HTMLElement | null>( null )
	const closeMenu = () => setAnchorEl( null )

	return (
		<>
			<Button
				size="small"
				color="inherit"
				aria-haspopup="menu"
				aria-expanded={anchorEl !== null}
				endIcon={<ArrowDownSLineIcon />}
				onClick={( e ) => setAnchorEl( e.currentTarget )}
			>
				Rows per page: {rowsPerPage}
			</Button>
			<Menu anchorEl={anchorEl} open={anchorEl !== null} onClose={closeMenu}>
				{ ROW_OPTIONS.map( ( rows ) => (
					<MenuItem
						key={rows}
						selected={rows === rowsPerPage}
						onClick={() => {
							closeMenu()
							setRowsPerPage( rows )
						}}
					>
						<ListItemIcon>
							{ rows === rowsPerPage && <CheckIcon fontSize="small" /> }
						</ListItemIcon>
						{rows} rows
					</MenuItem>
				) ) }
			</Menu>
		</>
	)
}
